var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCuartoCircleLineDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 232,
    viewBox: "0 0 205 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_561_17706",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 205,
    height: 232
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 232,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_561_17706)"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 21,
    r: 199.5,
    stroke: "#1C5029"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.000823975,
    cy: 20.9998,
    r: 180.895,
    stroke: "#1C5029"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.000320435,
    cy: 21.0002,
    r: 162.291,
    stroke: "#1C5029"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.000427246,
    cy: 20.9999,
    r: 145.377,
    stroke: "#1C5029"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuartoCircleLineDark);
export default __webpack_public_path__ + "static/media/cuartoCircleLineDark.7f265fb5181ad6e88f9fae891e1a0136.svg";
export { ForwardRef as ReactComponent };